import React, { useContext, useState } from "react";
import { LegacyCard as Card, Link, Collapsible, Text, Layout, InlineStack, VideoThumbnail } from "@shopify/polaris";
import { PrivateContext } from "lib/context";
import { withErrorBoundary } from "lib/hoc";
import constant from "lib/constant/constant";

import standardList from "./settingConfig";

const AdminSettings = () => {
  const { cms } = useContext(PrivateContext);
  const [openSetup, setOpenSetup] = useState({});
  const { imageURL } = constant;

  const handleSetupToggle = (key) => {
    setOpenSetup((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }));
  };

  const borderSet = {
    border: "0",
  };

  const iconHeightFix = {
    lineHeight: "2.2em",
  };

  return (standardList(cms) || []).map((settingList) => {
    return (
      <Layout.AnnotatedSection
        title={settingList.title}
        description={[
          <div>
            {settingList.isVideo && (
              <>
                <VideoThumbnail
                  videoLength={80}
                  // eslint-disable-next-line max-len
                  thumbnailUrl={imageURL.WELCOME}
                />
                <br />
              </>
            )}
            <Text as="span" tone="subdued">
              {settingList.description}
            </Text>
          </div>,
        ]}
      >
        {settingList.list.map((actionList) => {
          return (
            <Card>
              <Card.Header
                sectioned
                title={
                  // eslint-disable-next-line react/jsx-wrap-multilines
                  <InlineStack>
                    <i className={actionList.icon} style={iconHeightFix} />
                    <Text variant="headingMd" as="h2">
                      {actionList.title}
                      <Text as="span" tone="subdued">
                        <Text variant="bodySm" as="p">
                          {actionList.description}
                        </Text>
                      </Text>
                    </Text>
                  </InlineStack>
                }
                actions={[
                  {
                    content: openSetup[actionList.code] ? "Hide" : "Show",
                    onAction: () => handleSetupToggle(actionList.code),
                    disclosure: openSetup[actionList.code] ? "up" : "down",
                  },
                ]}
              />
              <br />
              <Collapsible open={openSetup[actionList.code]} id={`collapsible${actionList.code}`}>
                <Card.Section subdued>
                  {actionList.actions.map((step) => {
                    return (
                      <div style={borderSet}>
                        <Card.Section subdued>
                          <InlineStack>
                            <Link url={step.link}>{step.label}</Link>
                            <Text as="span">
                              <Text variant="bodySm" as="p">
                                {step.description}
                              </Text>
                            </Text>
                          </InlineStack>
                        </Card.Section>
                      </div>
                    );
                  })}
                  {actionList.isVideo && (
                    <Layout.AnnotatedSection
                      title={actionList.thumbnailHeader}
                      description={
                        // eslint-disable-next-line react/jsx-wrap-multilines
                        <div>
                          <VideoThumbnail videoLength={80} thumbnailUrl={actionList.thumbnail} />
                          <br />
                          <Text as="span">{actionList.thumbnailDescription}</Text>
                        </div>
                      }
                    />
                  )}
                </Card.Section>
              </Collapsible>
            </Card>
          );
        })}
      </Layout.AnnotatedSection>
    );
  });
};

export default withErrorBoundary(AdminSettings);
